import { CommonModule } from '@angular/common';
import {
  booleanAttribute,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Select } from 'primeng/select';
import { FormFieldComponent } from '../form-field/form-field.component';
import { regionCityOptions } from '../../constants/region-city-options';

@Component({
  selector: 'otw-region-city-selector',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Select, FormFieldComponent],
  templateUrl: './region-city-selector.component.html',
  styles: ``,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  host: {
    '[class]': 'classNames',
  },
})
export class RegionCitySelectorComponent implements OnInit {
  @Input() layout: 'horizontal' | 'vertical' = 'horizontal';
  @Input({ required: true }) controlKey = '';
  @Input() labelColor: 'white' | 'black' = 'black';
  @Input() classNames = '';
  @Input() containerClassNames = '';
  @Input() inputSize: 'small' | 'large' | null = null;
  @Input({ transform: booleanAttribute }) required!: boolean;

  parentContainer = inject(ControlContainer);
  get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }
  private regionsCities: { [key: string]: string[] } = regionCityOptions;
  regions: string[] = [];
  cities: string[] = [];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.parentFormGroup.addControl(
      this.controlKey,
      new FormGroup({
        region: new FormControl(
          null,
          this.required ? Validators.required : null
        ),
        city: new FormControl(null, this.required ? Validators.required : null),
      })
    );
    this.regions = Object.keys(this.regionsCities);

    const group = this.parentFormGroup.get(this.controlKey) as FormGroup;
    group.get('region')?.valueChanges.subscribe((region) => {
      this.cities = this.regionsCities[region] || [];
    });
  }

  ngOnDestroy(): void {
    this.parentFormGroup.removeControl(this.controlKey);
  }

  onRegionChange(region: string): void {
    this.cities = this.regionsCities[region] || [];
    const group = this.parentFormGroup.get(this.controlKey) as FormGroup;
    if (group) {
      group.get('city')?.setValue(null);
    }
  }
}
